// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"98fa183c","160":"990cf49b","208":"c5f80148","293":"721fdd1d","453":"cf3f8847","516":"a42808d1","519":"19f4186d","917":"c1375080","946":"423d6d23"}[chunkId] + ".chunk.js";
};